const designMore = (() => {
  const pageDesign = (document.getElementById("pageDesign") != null);
  if (pageDesign) {



    let secCntnts = document.querySelectorAll('.js-sec-cntnt');

    window.addEventListener('load', () => {

      secCntnts.forEach((element, index) => {

        let cntntWrap = element.querySelector('.js-cntnt-wrap');
        let btnMore = element.querySelector('.js-more-wrap .js-btn-box');
        let btnClose = element.querySelector('.js-cntnt-wrap .js-btn-box');

        let cntntWrapH = cntntWrap.clientHeight;
        cntntWrap.style.height = `${0}px`

        btnMore.addEventListener('click', () => {
          cntntWrap.style.height = `${cntntWrapH}px`
          cntntWrap.classList.add('act')
        });
        btnClose.addEventListener('click', () => {
          cntntWrap.style.height = `${0}px`
          cntntWrap.classList.remove('act')
        });

      });

    })



  }
})();
export default designMore;